import React, { useState, useEffect } from "react";
import WagerTypesConstants from "../../constants/WagerTypesConstants";
import WinPlaceShow from "./WinPlaceShow";
import Exacta from "./Exacta";
import Quinella from "./Quinella";
import Trifecta from "./Trifecta";
import Superfecta from "./Superfecta";
import HouseQuinella from "./HouseQuinella";
import Omni from "./Omni";
import High5 from "./High5";
import Picks from "./Picks";
import WagerTypes from "../../constants/WagerTypes";
import ErrorCodes from "../../constants/ErrorCodes";
import DailyDouble from "./DailyDouble";
import { useSelectFunctions } from "../../functions";

const ChartTabs = ({
  entries,
  getCharts,
  charts,
  activeBetTypes,
  raceID,
  logonSessionID,
  userInfo,
  raceNumber,
  setBetTypeSelected,
  activeChartTab,
  setActiveChartTab,
  sessionNoLongerExists,
  setSessionNoLongerExists,
  voidTickets,
  callTicketVoidListFrom,
  selectedTicketsVoidScore,
  setSelectedTicketsVoidScore,
  selectAllTickets,
  setSelectAllTickets,
  scoreTickets,
  setCallTicketVoidListFrom,
}) => {
  const [otherViews, setOtherViews] = useState(false);
  const [openBetsChart, setOpenBetsChart] = useState([]);
  const [idBetTypeSelected, setIdBetTypeSelected] = useState(0);
  const [selectionsSelected, setSelectionsSelected] = useState("");

  let wagerTypes = [],
    wagerTypeTab = [];

  const [wagerTypeStatus, setWagerTypeStatus] = useState(wagerTypes);
  const [pickSelected, setPickSelected] = useState({});
  const { getOpenBetsByChart } = useSelectFunctions();

  WagerTypesConstants.forEach((element) => {
    if (element.name === "Win") {
      wagerTypes.push({ [element.name]: true });
    } else {
      wagerTypes.push({ [element.name]: false });
    }
  });

  //Function that scrolls through the active betTypes to create tabs for each of them in the chart.
  if (activeBetTypes) {
    WagerTypesConstants.forEach((e) => {
      activeBetTypes.forEach((bt, i) => {
        if (bt.BetType === e.id) {
          if (e.id !== 1 && e.id !== 2 && e.id !== 0) {
            wagerTypeTab.push(
              <React.Fragment key={i}>
                <a
                  className={
                    "nav-link " + (activeChartTab === e.name ? "active" : "")
                  }
                  id={e.name + "-tab"}
                  data-toggle="tab"
                  href={"#" + e.name}
                  role="tab"
                  aria-controls="home"
                  aria-selected="true"
                  onClick={() => {
                    displayInfoChart(e.name, e.id);
                    setActiveChartTab(e.name);
                    setIdBetTypeSelected(e.id);
                  }}
                >
                  {e.name}
                </a>
              </React.Fragment>
            );
          }
        }
      });
    });
  }

  useEffect(() => {
    if (callTicketVoidListFrom && callTicketVoidListFrom.fromChartOpenBets) {
      getOpenBetsChartModal(idBetTypeSelected, selectionsSelected);
    }
  }, [callTicketVoidListFrom]);

  //Function that allows displaying the information for each WagerType in the Chart.
  const displayInfoChart = (wagerType, idBetType) => {
    let wagerTypes = [];

    WagerTypesConstants.forEach((element) => {
      if (element.name === wagerType) {
        wagerTypes.push({ [element.name]: true });
      } else {
        wagerTypes.push({ [element.name]: false });
      }
    });

    setWagerTypeStatus(wagerTypes);

    if (wagerType === "Win") {
      getCharts(idBetType);
      setBetTypeSelected(idBetType);
      setActiveChartTab("Win");
      setSelectedTicketsVoidScore([]);
    }

    if (wagerType === "Exacta") {
      getCharts(idBetType);
      setBetTypeSelected(idBetType);
      setActiveChartTab("Exacta");
      document.getElementById("Win-tab").classList.remove("active");
      setOtherViews(false);
      let chkE = document.getElementById("switchExacta");
      if (chkE) {
        chkE.checked = false;
      }
      setSelectedTicketsVoidScore([]);
    }

    if (wagerType === "Trifecta") {
      getCharts(idBetType);
      setBetTypeSelected(idBetType);
      setActiveChartTab("Trifecta");
      document.getElementById("Win-tab").classList.remove("active");
      setSelectedTicketsVoidScore([]);
    }

    if (wagerType === "Superfecta") {
      getCharts(idBetType);
      setBetTypeSelected(idBetType);
      setActiveChartTab("Superfecta");
      document.getElementById("Win-tab").classList.remove("active");
      setSelectedTicketsVoidScore([]);
    }

    if (wagerType === "Quinella") {
      getCharts(idBetType);
      setBetTypeSelected(idBetType);
      setActiveChartTab("Quinella");
      document.getElementById("Win-tab").classList.remove("active");
      setOtherViews(false);
      let chkQ = document.getElementById("switchQuinella");
      if (chkQ) {
        chkQ.checked = false;
      }
      setSelectedTicketsVoidScore([]);
    }

    if (wagerType === "HouseQuinella") {
      getCharts(idBetType);
      setBetTypeSelected(idBetType);
      setActiveChartTab("HouseQuinella");
      document.getElementById("Win-tab").classList.remove("active");
      setOtherViews(false);
      let chkHQ = document.getElementById("switchHQuinella");
      if (chkHQ) {
        chkHQ.checked = false;
      }
      setSelectedTicketsVoidScore([]);
    }

    if (wagerType === "Omni") {
      getCharts(idBetType);
      setBetTypeSelected(idBetType);
      setActiveChartTab("Omni");
      document.getElementById("Win-tab").classList.remove("active");
      setOtherViews(false);
      let chkOmni = document.getElementById("switchOmni");
      if (chkOmni) {
        chkOmni.checked = false;
      }
      setSelectedTicketsVoidScore([]);
    }

    if (wagerType === "High5") {
      getCharts(idBetType);
      setBetTypeSelected(idBetType);
      setActiveChartTab("High5");
      document.getElementById("Win-tab").classList.remove("active");
      setSelectedTicketsVoidScore([]);
    }

    if (wagerType.includes("Pick")) {
      setPickSelected(wagerType);
      getCharts(idBetType);
      setBetTypeSelected(idBetType);
      setActiveChartTab("Pick");
      document.getElementById("Win-tab").classList.remove("active");
      setSelectedTicketsVoidScore([]);
    }

    if (wagerType.includes("DailyDouble")) {
      getCharts(idBetType);
      setBetTypeSelected(idBetType);
      setActiveChartTab("DailyDouble");
      document.getElementById("Win-tab").classList.remove("active");
      setSelectedTicketsVoidScore([]);
    }

    if (wagerType.includes("GrandSlam")) {
      getCharts(idBetType);
      setActiveChartTab("GrandSlam");
      document.getElementById("Win-tab").classList.remove("active");
      setSelectedTicketsVoidScore([]);
    }
  };

  //Line 273:5:  'showPick' is assigned a value but never used  no-unused-vars
  //let showPick = false;
  if (wagerTypeStatus.some((item) => item[pickSelected] === true)) {
    //showPick = true;
  }

  if (pickSelected === activeChartTab) {
    //showPick = true;
  }

  const otherView = (e) => {
    if (e.checked) {
      setOtherViews(true);
    } else {
      setOtherViews(false);
    }
  };

  //Function to load Open Bets info by Entry for each betType (Modal)
  const getOpenBetsChartModal = async (ticketType, selections) => {
    const res = await getOpenBetsByChart(
      {
        RaceID: raceID,
        TicketType: ticketType,
        Selections: selections.toString(),
      },
      logonSessionID
    );

    if (res?.error) {
      if (
        res.Result === ErrorCodes.InvalidSession ||
        res.Result === ErrorCodes.SessionNoLongerExists
      ) {
        setSessionNoLongerExists(true);
      }
      return;
    } else {
      setOpenBetsChart(res.RaceTicketMainList);
    }
  };

  return (
    <>
      <div
        className="scrollmenu nav nav-tabs"
        style={{ display: "block" }}
        id="myTab"
        role="tablist"
      >
        <a
          className={"nav-link " + (activeChartTab === "Win" ? "active" : "")}
          key={0}
          id={"Win-tab"}
          data-toggle="tab"
          href={"#Win"}
          role="tab"
          aria-controls="home"
          aria-selected="true"
          onClick={() => displayInfoChart("Win", 0)}
        >
          Win/Place/Show
        </a>
        {wagerTypeTab}
      </div>
      <div
        className="tab-content"
        id="myTabContent"
        style={{ paddingLeft: "15px", paddingRight: "15px" }}
      >
        {/* Win/Place/Show Component  */}
        {activeChartTab === "Win" && (
          <WinPlaceShow
            key={0}
            entries={entries}
            charts={charts}
            getOpenBetsChartModal={getOpenBetsChartModal}
            openBetsChartInfo={openBetsChart}
            setOpenBetsChartInfo={setOpenBetsChart}
            userInfo={userInfo}
            idWin={WagerTypes.WIN.id}
            raceID={raceID}
            sessionNoLongerExists={sessionNoLongerExists}
            setSessionNoLongerExists={setSessionNoLongerExists}
            voidTickets={voidTickets}
            callTicketVoidListFrom={callTicketVoidListFrom}
            selectedTicketsVoidScore={selectedTicketsVoidScore}
            setSelectedTicketsVoidScore={setSelectedTicketsVoidScore}
            selectAllTickets={selectAllTickets}
            setSelectAllTickets={setSelectAllTickets}
            scoreTickets={scoreTickets}
            setCallTicketVoidListFrom={setCallTicketVoidListFrom}
            setSelectionsSelected={setSelectionsSelected}
            getCharts={getCharts}
          />
        )}

        {/* Quinella Component  */}
        {activeChartTab === "Quinella" && (
          <div
            className="tab-pane fade show active"
            id="Quinella"
            role="tabpanel"
            aria-labelledby="Quinella"
          >
            <>
              <div className="custom-control custom-switch">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id="switchQuinella"
                  name="example"
                  onClick={(e) => otherView(e.target)}
                />
                <label
                  className="custom-control-label lead"
                  htmlFor="switchQuinella"
                  style={{ color: "#888", fontSize: "18px" }}
                >
                  Flat View
                </label>
              </div>
            </>
            <Quinella
              key={1}
              entries={entries}
              charts={charts}
              otherViews={otherViews}
              getOpenBetsChartModal={getOpenBetsChartModal}
              openBetsChartInfo={openBetsChart}
              setOpenBetsChartInfo={setOpenBetsChart}
              userInfo={userInfo}
              idQuinella={WagerTypes.QUINELLA.id}
              raceID={raceID}
              voidTickets={voidTickets}
              callTicketVoidListFrom={callTicketVoidListFrom}
              selectedTicketsVoidScore={selectedTicketsVoidScore}
              setSelectedTicketsVoidScore={setSelectedTicketsVoidScore}
              selectAllTickets={selectAllTickets}
              setSelectAllTickets={setSelectAllTickets}
              scoreTickets={scoreTickets}
              setCallTicketVoidListFrom={setCallTicketVoidListFrom}
              setSelectionsSelected={setSelectionsSelected}
              getCharts={getCharts}
            />
          </div>
        )}

        {/* Exacta Component  */}
        {activeChartTab === "Exacta" && (
          <div
            className="tab-pane fade show active"
            id="Exacta"
            role="tabpanel"
            aria-labelledby="Exacta"
          >
            <>
              <div className="form-inline">
                <div className="custom-control custom-switch">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="switchExacta"
                    name="example"
                    onClick={(e) => otherView(e.target)}
                  />
                  <label
                    className="custom-control-label lead"
                    htmlFor="switchExacta"
                    style={{ color: "#888", fontSize: "18px" }}
                  >
                    Flat View
                  </label>
                </div>
              </div>
            </>
            <Exacta
              key={2}
              entries={entries}
              charts={charts}
              otherViews={otherViews}
              getOpenBetsChartModal={getOpenBetsChartModal}
              openBetsChartInfo={openBetsChart}
              setOpenBetsChartInfo={setOpenBetsChart}
              userInfo={userInfo}
              idExacta={WagerTypes.EXACTA.id}
              raceID={raceID}
              voidTickets={voidTickets}
              callTicketVoidListFrom={callTicketVoidListFrom}
              selectedTicketsVoidScore={selectedTicketsVoidScore}
              setSelectedTicketsVoidScore={setSelectedTicketsVoidScore}
              selectAllTickets={selectAllTickets}
              setSelectAllTickets={setSelectAllTickets}
              scoreTickets={scoreTickets}
              setCallTicketVoidListFrom={setCallTicketVoidListFrom}
              setSelectionsSelected={setSelectionsSelected}
              getCharts={getCharts}
            />
          </div>
        )}

        {/* Trifecta Component  */}
        {activeChartTab === "Trifecta" && (
          <div
            className="tab-pane fade show active"
            id="Trifecta"
            role="tabpanel"
            aria-labelledby="Trifecta"
          >
            <Trifecta
              key={3}
              charts={charts}
              getOpenBetsChartModal={getOpenBetsChartModal}
              openBetsChartInfo={openBetsChart}
              setOpenBetsChartInfo={setOpenBetsChart}
              userInfo={userInfo}
              idTrifecta={WagerTypes.TRIFECTA.id}
              raceID={raceID}
              voidTickets={voidTickets}
              callTicketVoidListFrom={callTicketVoidListFrom}
              selectedTicketsVoidScore={selectedTicketsVoidScore}
              setSelectedTicketsVoidScore={setSelectedTicketsVoidScore}
              selectAllTickets={selectAllTickets}
              setSelectAllTickets={setSelectAllTickets}
              scoreTickets={scoreTickets}
              setCallTicketVoidListFrom={setCallTicketVoidListFrom}
              setSelectionsSelected={setSelectionsSelected}
              getCharts={getCharts}
            />
          </div>
        )}

        {/* Superfecta Component  */}
        {activeChartTab === "Superfecta" && (
          <div
            className="tab-pane fade show active"
            id="Superfecta"
            role="tabpanel"
            aria-labelledby="Superfecta"
          >
            <Superfecta
              key={4}
              charts={charts}
              getOpenBetsChartModal={getOpenBetsChartModal}
              openBetsChartInfo={openBetsChart}
              setOpenBetsChartInfo={setOpenBetsChart}
              userInfo={userInfo}
              idSuperfecta={WagerTypes.SUPERFECTA.id}
              raceID={raceID}
              voidTickets={voidTickets}
              callTicketVoidListFrom={callTicketVoidListFrom}
              selectedTicketsVoidScore={selectedTicketsVoidScore}
              setSelectedTicketsVoidScore={setSelectedTicketsVoidScore}
              selectAllTickets={selectAllTickets}
              setSelectAllTickets={setSelectAllTickets}
              scoreTickets={scoreTickets}
              setCallTicketVoidListFrom={setCallTicketVoidListFrom}
              setSelectionsSelected={setSelectionsSelected}
              getCharts={getCharts}
            />
          </div>
        )}

        {/* HouseQ Component  */}
        {activeChartTab === "HouseQ" && (
          <div
            className="tab-pane fade show active"
            id="HouseQ"
            role="tabpanel"
            aria-labelledby="HouseQ"
          >
            <>
              <div className="custom-control custom-switch">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id="switchHQuinella"
                  name="example"
                  onClick={(e) => otherView(e.target)}
                />
                <label
                  className="custom-control-label lead"
                  htmlFor="switchHQuinella"
                  style={{ color: "#888", fontSize: "18px" }}
                >
                  Flat View
                </label>
              </div>
            </>
            <HouseQuinella
              key={5}
              entries={entries}
              charts={charts}
              otherViews={otherViews}
              getOpenBetsChartModal={getOpenBetsChartModal}
              openBetsChartInfo={openBetsChart}
              setOpenBetsChartInfo={setOpenBetsChart}
              userInfo={userInfo}
              idHouseQ={WagerTypes.HOUSEQ.id}
              raceID={raceID}
              voidTickets={voidTickets}
              callTicketVoidListFrom={callTicketVoidListFrom}
              selectedTicketsVoidScore={selectedTicketsVoidScore}
              setSelectedTicketsVoidScore={setSelectedTicketsVoidScore}
              selectAllTickets={selectAllTickets}
              setSelectAllTickets={setSelectAllTickets}
              scoreTickets={scoreTickets}
              setCallTicketVoidListFrom={setCallTicketVoidListFrom}
              setSelectionsSelected={setSelectionsSelected}
              getCharts={getCharts}
            />
          </div>
        )}

        {/* Omni Component  */}
        {activeChartTab === "Omni" && (
          <div
            className="tab-pane fade show active"
            id="Omni"
            role="tabpanel"
            aria-labelledby="Omni"
          >
            <>
              <div className="custom-control custom-switch">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id="switchOmni"
                  name="example"
                  onClick={(e) => otherView(e.target)}
                />
                <label
                  className="custom-control-label lead"
                  htmlFor="switchOmni"
                  style={{ color: "#888", fontSize: "18px" }}
                >
                  Flat View
                </label>
              </div>
            </>
            <Omni
              key={6}
              entries={entries}
              charts={charts}
              otherViews={otherViews}
              getOpenBetsChartModal={getOpenBetsChartModal}
              openBetsChartInfo={openBetsChart}
              setOpenBetsChartInfo={setOpenBetsChart}
              userInfo={userInfo}
              idOmni={WagerTypes.OMNI.id}
              raceID={raceID}
              voidTickets={voidTickets}
              callTicketVoidListFrom={callTicketVoidListFrom}
              selectedTicketsVoidScore={selectedTicketsVoidScore}
              setSelectedTicketsVoidScore={setSelectedTicketsVoidScore}
              selectAllTickets={selectAllTickets}
              setSelectAllTickets={setSelectAllTickets}
              scoreTickets={scoreTickets}
              setCallTicketVoidListFrom={setCallTicketVoidListFrom}
              setSelectionsSelected={setSelectionsSelected}
              getCharts={getCharts}
            />
          </div>
        )}

        {/* High5 Component  */}
        {activeChartTab === "High5" && (
          <div
            className="tab-pane fade show active"
            id="High5"
            role="tabpanel"
            aria-labelledby="High5"
            key={44}
          >
            <High5
              key={7}
              charts={charts}
              getOpenBetsChartModal={getOpenBetsChartModal}
              openBetsChartInfo={openBetsChart}
              setOpenBetsChartInfo={setOpenBetsChart}
              userInfo={userInfo}
              idHigh5={WagerTypes.HIGH5.id}
              raceID={raceID}
              voidTickets={voidTickets}
              callTicketVoidListFrom={callTicketVoidListFrom}
              selectedTicketsVoidScore={selectedTicketsVoidScore}
              setSelectedTicketsVoidScore={setSelectedTicketsVoidScore}
              selectAllTickets={selectAllTickets}
              setSelectAllTickets={setSelectAllTickets}
              scoreTickets={scoreTickets}
              setCallTicketVoidListFrom={setCallTicketVoidListFrom}
              setSelectionsSelected={setSelectionsSelected}
              getCharts={getCharts}
            />
          </div>
        )}

        {/* Picks Component */}
        {activeChartTab.includes("Pick") && (
          <Picks
            key={8}
            charts={charts}
            getOpenBetsChartModal={getOpenBetsChartModal}
            openBetsChartInfo={openBetsChart}
            setOpenBetsChartInfo={setOpenBetsChart}
            userInfo={userInfo}
            idPick={WagerTypes[activeChartTab.toUpperCase()].id}
            pickNumber={WagerTypes[activeChartTab.toUpperCase()].pickNumber}
            raceNumber={raceNumber}
            raceID={raceID}
            voidTickets={voidTickets}
            callTicketVoidListFrom={callTicketVoidListFrom}
            selectedTicketsVoidScore={selectedTicketsVoidScore}
            setSelectedTicketsVoidScore={setSelectedTicketsVoidScore}
            selectAllTickets={selectAllTickets}
            setSelectAllTickets={setSelectAllTickets}
            scoreTickets={scoreTickets}
            setCallTicketVoidListFrom={setCallTicketVoidListFrom}
            setSelectionsSelected={setSelectionsSelected}
            getCharts={getCharts}
          />
        )}

        {/* High5 Component  */}
        {activeChartTab === "DailyDouble" && (
          <div
            className="tab-pane fade show active"
            id="DailyDouble"
            role="tabpanel"
            aria-labelledby="DailyDouble"
            key={46}
          >
            <DailyDouble
              key={9}
              charts={charts}
              getOpenBetsChartModal={getOpenBetsChartModal}
              openBetsChartInfo={openBetsChart}
              setOpenBetsChartInfo={setOpenBetsChart}
              userInfo={userInfo}
              idDailyDouble={WagerTypes.DAILYDOUBLE.id}
              raceNumber={raceNumber}
              raceID={raceID}
              voidTickets={voidTickets}
              callTicketVoidListFrom={callTicketVoidListFrom}
              selectedTicketsVoidScore={selectedTicketsVoidScore}
              setSelectedTicketsVoidScore={setSelectedTicketsVoidScore}
              selectAllTickets={selectAllTickets}
              setSelectAllTickets={setSelectAllTickets}
              scoreTickets={scoreTickets}
              setCallTicketVoidListFrom={setCallTicketVoidListFrom}
              setSelectionsSelected={setSelectionsSelected}
              getCharts={getCharts}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default ChartTabs;
